import { render, staticRenderFns } from "./FunctionalComponent.vue?vue&type=template&id=6337de0a&functional=true&"
import script from "./FunctionalComponent.vue?vue&type=script&lang=js&"
export * from "./FunctionalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports